import { Component, Input, OnInit, OnDestroy, AfterContentInit, inject } from '@angular/core';
import { Inject } from '@angular/core';
import View from 'ol/View';
import { easeOut } from 'ol/easing.js';
import { fromExtent as polygonFromExtent } from 'ol/geom/Polygon.js';
import { TT_LIB_CONFIG } from '../../tt-lib.config.token';
import { AppConfig } from '../../interfaces/app-config'
import { MapService } from '../../services/map.service';
import { ControlService } from '../../services/control.service';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { GeolocationComponent } from '../geolocation/geolocation.component';
import { ViewService } from '@tt-lib/services/view.service';
import { ToggleEventNameType, ToggleEventService } from '@tt-lib/services/toggle-event.service';

@Component({
  selector: 'tt-zoom',
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    GeolocationComponent
  ],
  templateUrl: './zoom.component.html',
  styleUrls: ['./zoom.component.scss'],
  standalone: true
})
export class ZoomComponent implements OnInit {

  @Input() axis: string = 'vertical';
  geolocation: boolean;
  zoomAllBtn: boolean;

  view: View;
  duration: number = 250;
  zoomAllExtent: number[];
  private ttLibConfig = inject<AppConfig>(TT_LIB_CONFIG);

  constructor(
    public mapService: MapService,
    public controlService: ControlService,
    private viewService: ViewService,
    private toggleEventService: ToggleEventService
  ) { }

  ngOnInit(): void {
    this.geolocation = this.ttLibConfig.map.controls.geolocation;
    this.zoomAllBtn = this.ttLibConfig.map.controls.zoomToExtent.zoomAllBtn;
  }

  ngAfterContentInit() {
    //this.view = this.mapService.getMap().getView();
    this.viewService.viewReady$.subscribe((ready => this.view = this.mapService.getMap().getView()));
    this.zoomAllExtent = this.controlService.getZoomAllExtent();
  }

  onZoomIn() {
    this.zoomByDelta(+1);
  }

  onZoomOut() {
    this.zoomByDelta(-1);
  }

  private zoomByDelta(delta: number) {
    if (!this.view) {
      // the map does not have a view, so we can't act
      // upon it
      return;
    }
    const currentZoom = this.view.getZoom();
    if (currentZoom !== undefined) {
      const newZoom = this.view.getConstrainedZoom(currentZoom + delta);
      if (this.duration > 0) {
        if (this.view.getAnimating()) {
          this.view.cancelAnimations();
        }
        this.view.animate({
          zoom: newZoom,
          duration: this.duration,
          easing: easeOut,
        });
      } else {
        this.view.setZoom(newZoom);
      }
    }
  }

  onZoomAll() {
    //geolocation is listening for recenter
    this.toggleEventService.toggleEvent({
      forwardedFor: 'zoom-zoomall',
      eventName: ToggleEventNameType.ACTIVE
    });
    const extent = (!this.zoomAllExtent) ? this.view.getProjection().getExtent() : this.zoomAllExtent;
    this.view.fitInternal(
      polygonFromExtent(extent),
      {
        callback: () => {
          this.toggleEventService.toggleEvent({
            forwardedFor: 'zoom-zoomall',
            eventName: ToggleEventNameType.INACTIVE
          });
        }
      });
  }

}
